"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertLinkDirectly = insertLinkDirectly;
exports.splitBlockQuotes = exports.isValidColor = exports.applyNodeStyle = exports.isAddingUndoLevelWithPlaceholderImg = exports.autoResizeHandler = exports.isLinkNode = exports.getLinkNode = exports.openLink = exports.removeLink = exports.insertSignatureImages = exports.uploadBase64Images = exports.uploadInlineImages = exports.getUploadImageSize = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _uuid = _interopRequireDefault(require("uuid"));

var _chromaJs = _interopRequireDefault(require("chroma-js"));

var _constants = require("./constants");

var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getUploadImageSize = function getUploadImageSize(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      resolve(getBestFitSize({
        width: this.width,
        height: this.height
      }));
    };

    img.onerror = function (e) {
      return reject(e);
    };

    img.src = src;
  });
};

exports.getUploadImageSize = getUploadImageSize;
var SIZE_BEST_FIT = 472;

function getBestFitSize(_ref) {
  var width = _ref.width,
      height = _ref.height;
  var ratio = width / height;

  if (width > SIZE_BEST_FIT || height > SIZE_BEST_FIT) {
    if (ratio > 1) {
      return {
        width: SIZE_BEST_FIT,
        height: SIZE_BEST_FIT / ratio
      };
    } else {
      return {
        width: ratio * SIZE_BEST_FIT,
        height: SIZE_BEST_FIT
      };
    }
  } else {
    return {
      width: width,
      height: height
    };
  }
}

var getImageBase64 = function getImageBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (e) {
      return reject(e);
    };

    reader.readAsDataURL(file);
  });
};

var uploadInlineImages = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(editor, files, uploadHandler) {
    var images;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            images = (0, _toConsumableArray2["default"])(files).map(function (file) {
              var id = (0, _uuid["default"])(); // Insert placeholder image

              editor.selection.setContent("<div contenteditable=\"false\" class=\"uploading-placeholder\" id=\"".concat(id, "\" ><div  style=\"display: inline-block; \n width: 600px;\n height: 400px;\n \n background-color: #f6f9fc;\n \">\n <img src=\"https://assets.edison.tech/onmail/photo-loading.png\" width=\"100px\" height=\"100px\" alt=\"uploading\" style=\"display: block;margin: auto; margin-top: 130px\">\n </div></div><br data-bogus=\"1\">"));
              return {
                file: file,
                id: id
              };
            });
            images.forEach(function (_ref3) {
              var file = _ref3.file,
                  id = _ref3.id;
              var src = URL.createObjectURL(file);
              Promise.all([uploadHandler(file), getUploadImageSize(src)]).then(function (_ref4) {
                var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
                    res = _ref5[0],
                    size = _ref5[1];

                var $ = _tinymce["default"].dom.DomQuery;
                $("#".concat(id), editor.getBody()).replaceWith($('<img />').attr(_objectSpread(_objectSpread({}, size), {}, {
                  src: src,
                  'data-cid': res
                })).on('load', function () {
                  autoResizeHandler(editor);
                }));
                editor.setDirty(true);
                editor.fire('change');
              })["catch"](function (err) {
                // remove placeholder image if upload failed
                editor.dom.remove(id);
              });
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadInlineImages(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.uploadInlineImages = uploadInlineImages;

var loadExternalImage = function loadExternalImage(node) {
  return new Promise(function (resolve, reject) {
    resolve(node.getAttribute('data-src'));
  });
};

var uploadBase64Images = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(editor, files) {
    var images;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all((0, _toConsumableArray2["default"])(files).map(function (file) {
              var src = URL.createObjectURL(file);
              return Promise.all([getUploadImageSize(src), getImageBase64(file)]);
            }));

          case 2:
            images = _context2.sent;
            images.forEach(function (_ref7) {
              var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
                  size = _ref8[0],
                  src = _ref8[1];

              editor.selection.setNode(editor.dom.create('img', _objectSpread({
                src: src
              }, size)));
            });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function uploadBase64Images(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

exports.uploadBase64Images = uploadBase64Images;

var insertSignatureImages = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(editor, files) {
    var images;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all((0, _toConsumableArray2["default"])(files).map(function (item) {
              return Promise.all([item, getUploadImageSize(item.url)]);
            }));

          case 2:
            images = _context3.sent;
            images.forEach(function (_ref10) {
              var _ref11 = (0, _slicedToArray2["default"])(_ref10, 2),
                  image = _ref11[0],
                  size = _ref11[1];

              var url = image.url,
                  id = image.id;
              editor.selection.setNode(editor.dom.create('img', _objectSpread({
                src: url
              }, size)));
            });
            editor.setDirty(true);
            editor.fire('change');

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function insertSignatureImages(_x6, _x7) {
    return _ref9.apply(this, arguments);
  };
}();

exports.insertSignatureImages = insertSignatureImages;

var removeLink = function removeLink(editor) {
  editor.execCommand('Unlink');
};

exports.removeLink = removeLink;

var openLink = function openLink(editor) {
  var linkNode = getLinkNode(editor);
  var url = linkNode.getAttribute('href');
  window.open(url, '_blank');
};

exports.openLink = openLink;

var getLinkNode = function getLinkNode(editor) {
  return editor.dom.getParents(editor.selection.getNode()).find(function (node) {
    return node.nodeName === 'A';
  });
};

exports.getLinkNode = getLinkNode;

var isLinkNode = function isLinkNode(editor, link) {
  return editor.dom.is(link, 'a') && editor.getBody().contains(link);
};

exports.isLinkNode = isLinkNode;

function insertLinkDirectly(editor) {
  if (editor.selection.isCollapsed()) {
    return false;
  } else {
    var content = editor.selection.getContent();
    var div = document.createElement('div');
    div.innerHTML = content;
    var text = div.innerText.trim();

    if (text && (0, _utils.isURL)(text)) {
      editor.execCommand('mceInsertLink', false, text);
      return true;
    }
  }

  return false;
}

var autoResizeHandler = function autoResizeHandler(editor) {
  var doc = editor.getDoc();

  if (!doc) {
    return;
  }

  var container = editor.getContainer();
  var docEle = doc.documentElement;
  container.style.height = "".concat(docEle.offsetHeight, "px");
};

exports.autoResizeHandler = autoResizeHandler;

var isAddingUndoLevelWithPlaceholderImg = function isAddingUndoLevelWithPlaceholderImg(content) {
  return content.includes("<div contenteditable=\"false\" class=\"uploading-placeholder\"");
};

exports.isAddingUndoLevelWithPlaceholderImg = isAddingUndoLevelWithPlaceholderImg;

var applyNodeStyle = function applyNodeStyle(Styles, node, newStyle) {
  var style = Styles.parse(node.attr('style'));
  node.attr('style', Styles.serialize(_objectSpread(_objectSpread({}, style), newStyle)));
};

exports.applyNodeStyle = applyNodeStyle;

var isValidColor = function isValidColor(color) {
  return color && _chromaJs["default"].valid(color) && (0, _chromaJs["default"])(color).get('rgba.a') !== 0;
};

exports.isValidColor = isValidColor;

var splitBlockQuotes = function splitBlockQuotes(editor, event) {// const currentNode = editor.selection.getNode()
  // if (!currentNode) return
  // const blockquoteNode = editor.dom.getParent(currentNode, 'blockquote')
  // if (!blockquoteNode) return
  // const lineText = currentNode.innerHTML
  // let newBlock = editor.dom.create('div')
  // newBlock.innerHTML = `${lineText}`
  // editor.dom.split(blockquoteNode, currentNode, newBlock)
  // editor.selection.setCursorLocation(newBlock, 0)
};

exports.splitBlockQuotes = splitBlockQuotes;
//# sourceMappingURL=utils.js.map